/* Solvana OS — gesamtes Theme-JS. Vanilla, event-delegiert, kein Framework. */
(function () {
  'use strict';
  var S = window.SolvanaOS || { routes: {}, strings: {} };

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    var fmt = S.moneyFormat || '€{{amount}}';
    return fmt.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, value).replace(/<[^>]+>/g, '');
  }

  /* ---------- Drawer (Cart + Mobile-Nav) ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-lock');
    var focusEl = d.querySelector('[data-autofocus]') || d.querySelector('button, a, input');
    if (focusEl) focusEl.focus({ preventScroll: true });
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('drawer-lock');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart-API + Drawer-Refresh ---------- */
  function refreshCartUI(openAfter) {
    return Promise.all([
      fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }),
      fetch(S.routes.cart_url + '.js').then(function (r) { return r.json(); })
    ]).then(function (results) {
      var drawerHtml = results[0]['cart-drawer'];
      var target = $('#CartDrawerInner');
      if (target && drawerHtml) {
        var tmp = document.createElement('div');
        tmp.innerHTML = drawerHtml;
        var fresh = tmp.querySelector('#CartDrawerInner');
        if (fresh) target.innerHTML = fresh.innerHTML;
      }
      var bubble = $('#CartBubble');
      if (bubble) {
        var n = results[1].item_count || 0;
        bubble.textContent = n;
        bubble.hidden = n === 0;
      }
      if (openAfter) openDrawer('CartDrawer');
    });
  }
  window.solCartAdd = function (items, onDone) {
    return fetch(S.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || S.strings.cartError); });
        return r.json();
      })
      .then(function () { return refreshCartUI(true); })
      .then(function () { if (onDone) onDone(true); })
      .catch(function (err) { if (onDone) onDone(false, err); else alert(err.message || S.strings.cartError); });
  };
  function cartChange(key, qty) {
    return fetch(S.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return refreshCartUI(false); });
  }

  /* Drawer: Menge ändern / entfernen (delegiert, überlebt Re-Renders) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (btn) {
      var key = btn.getAttribute('data-key');
      var qty = parseInt(btn.getAttribute('data-cart-qty'), 10);
      btn.setAttribute('aria-busy', 'true');
      cartChange(key, qty);
      return;
    }
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { rm.setAttribute('aria-busy', 'true'); cartChange(rm.getAttribute('data-cart-remove'), 0); }
  });

  /* Quick-Add von Produktkarten */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    window.solCartAdd([{ id: parseInt(btn.getAttribute('data-quick-add'), 10), quantity: 1 }], function (ok) {
      btn.removeAttribute('aria-busy');
      if (!ok) btn.textContent = S.strings.unavailable;
    });
  });

  /* Upsell im Drawer */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    window.solCartAdd([{ id: parseInt(btn.getAttribute('data-upsell-add'), 10), quantity: 1 }], function () {});
  });

  /* ---------- Mengen-Stepper (generisch) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty button');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += btn.getAttribute('data-step') === 'down' ? -1 : 1;
    input.value = Math.max(parseInt(input.min, 10) || 1, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Vorher/Nachher-Slider ---------- */
  document.addEventListener('input', function (e) {
    var range = e.target.closest ? e.target.closest('[data-ba-range]') : null;
    if (!range) return;
    var box = range.closest('[data-before-after]');
    if (box) box.style.setProperty('--pos', range.value + '%');
  });
  document.addEventListener('DOMContentLoaded', function () {
    $$('[data-before-after]').forEach(function (box) {
      var range = box.querySelector('[data-ba-range]');
      if (range) box.style.setProperty('--pos', range.value + '%');
    });
  });

  /* ---------- Produktseite ---------- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var form = root.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var submit = form && form.querySelector('[data-add-button]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var atcSave = root.querySelector('[data-atc-save]');
    var mainImg = root.querySelector('[data-main-image]');
    var activeVariant = null;

    /* Preise einer Bundle-Karte für die aktuelle Variante berechnen */
    function bundleFigures(opt, v) {
      var mainReg = v.compare_at_price > v.price ? v.compare_at_price : v.price;
      var pp = parseInt(opt.getAttribute('data-partner-price'), 10);
      if (isNaN(pp)) return { now: v.price, reg: mainReg, save: mainReg - v.price };
      var partnerReg = parseInt(opt.getAttribute('data-partner-reg'), 10) || pp;
      var disc = (parseFloat(opt.getAttribute('data-discount')) || 0) / 100;
      var now = v.price + pp - Math.floor(pp * disc);
      return { now: now, reg: mainReg + partnerReg, save: mainReg + partnerReg - now };
    }
    function renderBundles(v) {
      $$('.pdp-bundle__opt', root).forEach(function (opt) {
        var f = bundleFigures(opt, v);
        opt.setAttribute('data-save', f.save);
        var now = opt.querySelector('[data-bundle-now]');
        var was = opt.querySelector('[data-bundle-was]');
        var sav = opt.querySelector('[data-bundle-save]');
        if (now) now.textContent = formatMoney(f.now);
        if (was) { was.textContent = formatMoney(f.reg); was.hidden = f.save <= 0; }
        if (sav) { sav.textContent = 'Spare ' + formatMoney(f.save); sav.hidden = f.save <= 0; }
      });
      renderAtcSave();
    }
    /* Sparzeile im Kauf-Button folgt der gewählten Bundle-Option */
    function renderAtcSave() {
      if (!atcSave) return;
      var sel = root.querySelector('.pdp-bundle__opt.is-sel');
      var save;
      if (sel) save = parseInt(sel.getAttribute('data-save'), 10) || 0;
      else if (activeVariant) save = Math.max(0, (activeVariant.compare_at_price || 0) - activeVariant.price);
      else save = 0;
      atcSave.textContent = 'Du sparst ' + formatMoney(save);
      atcSave.hidden = save <= 0;
    }

    function currentVariant() {
      var opts = $$('[data-option-select]', root).map(function (s) { return s.value; });
      if (!opts.length) return product.variants[0];
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function renderVariant(v) {
      if (!v) {
        if (submit) { submit.disabled = true; }
        if (atcLabel) atcLabel.textContent = S.strings.unavailable;
        if (atcSave) atcSave.hidden = true;
        return;
      }
      activeVariant = v;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (priceWas) {
        if (v.compare_at_price > v.price) { priceWas.textContent = formatMoney(v.compare_at_price); priceWas.hidden = false; }
        else priceWas.hidden = true;
      }
      if (submit) submit.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? S.strings.addToCart : S.strings.soldOut;
      if (v.featured_image && mainImg) mainImg.src = v.featured_image.src;
      var sticky = $('[data-sticky-price]');
      if (sticky) sticky.textContent = formatMoney(v.price);
      renderBundles(v);
    }
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-select]')) renderVariant(currentVariant());
    });

    /* Galerie: Thumb → Hauptbild */
    function galleryPreload() {
      var thumbs = $$('[data-thumb]', root);
      if (!thumbs.length) return;
      var idx = thumbs.findIndex(function (x) { return x.classList.contains('is-active'); });
      if (idx < 0) idx = 0;
      [1, -1, 2].forEach(function (d) {
        var t = thumbs[(idx + d + thumbs.length) % thumbs.length];
        if (t && !t.__pre) { t.__pre = new Image(); t.__pre.src = t.getAttribute('data-thumb'); }
      });
    }
    function galleryShow(thumb) {
      if (!thumb || !mainImg) return;
      var url = thumb.getAttribute('data-thumb');
      $$('[data-thumb]', root).forEach(function (x) { x.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      mainImg.style.opacity = '0.35';
      var pre = new Image();
      pre.src = url;
      var apply = function () { mainImg.src = url; mainImg.style.opacity = '1'; galleryPreload(); };
      if (pre.decode) { pre.decode().then(apply).catch(apply); } else { pre.onload = apply; pre.onerror = apply; }
    }
    function galleryStep(dir) {
      var thumbs = $$('[data-thumb]', root);
      if (!thumbs.length) return;
      var idx = thumbs.findIndex(function (x) { return x.classList.contains('is-active'); });
      if (idx < 0) idx = 0;
      galleryShow(thumbs[(idx + dir + thumbs.length) % thumbs.length]);
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-gal-prev]')) return galleryStep(-1);
      if (e.target.closest('[data-gal-next]')) return galleryStep(1);
      var t = e.target.closest('[data-thumb]');
      if (t) galleryShow(t);
    });
    galleryPreload();

    /* Add-to-Cart (mit optionalem Bundle) */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items = [];
        var bundleSel = root.querySelector('.pdp-bundle__opt.is-sel');
        var qty = parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1;
        items.push({ id: parseInt(idInput.value, 10), quantity: qty });
        if (bundleSel) {
          var addons = bundleSel.getAttribute('data-addons');
          if (addons) {
            addons.split(',').forEach(function (id) {
              if (id) items.push({ id: parseInt(id, 10), quantity: 1 });
            });
          }
        }
        submit.setAttribute('aria-busy', 'true');
        window.solCartAdd(items, function () { submit.removeAttribute('aria-busy'); });
      });
    }

    /* Bundle-Optionen wählen */
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.pdp-bundle__opt');
      if (!opt) return;
      $$('.pdp-bundle__opt', root).forEach(function (x) { x.classList.remove('is-sel'); });
      opt.classList.add('is-sel');
      renderAtcSave();
    });

    /* Sticky-ATC: einblenden, wenn Buy-Button aus dem Bild scrollt */
    var stickyBar = $('[data-sticky-atc]');
    if (stickyBar && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-on', !entries[0].isIntersecting);
      }, { rootMargin: '-80px 0px 0px 0px' }).observe(submit);
      stickyBar.addEventListener('click', function (e) {
        if (e.target.closest('[data-sticky-add]')) { e.preventDefault(); submit.click(); }
      });
    }
    renderVariant(currentVariant());
  }
  $$('[data-product-root]').forEach(initProduct);

  /* ---------- Header: Schatten bei Scroll ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
